import React, { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import LuckyGift from "../../../assets/images/boxes.png"
import PulaLogo from "../../../assets/images/pula-logo.svg"

const Congrats = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const { state } = location

  console.log("state", state)

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(`/events-info`) // Change this path to your actual detail page route
    }, 10000) // 10 seconds

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div
        className="container-fluid"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <div className="bg-primary py-5 congrats-wrapper">
          <div className="container mx-auto px-4 ">
            <div className="congrats-box">
              <div className="congrats-bg bg-lightpink text-center px-6 pt-4 md:pt-10">
                <div className="mb-12">
                  <img
                    src={PulaLogo}
                    className="w-auto md:w-40 mx-auto block"
                    alt="PULA LOGO"
                  />
                  {/*  <h1 className="text-[#880356] pt-8 md:pb-3 text-[28px] sm:text-3xl md:text-5xl font-semibold capitalize">
                Congratulations!
              </h1> */}
                  <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mt-4 mb-2 text-success">
                    Booking Confirmed!
                  </h2>
                  <p className="font-normal !text-gray50 text-sm sm:text-base mt-2 mb-2">
                    Thank you for booking your pass for{" "}
                    <b>{state.eventData.title}</b>{" "}
                    {/* <b>PULA Business Networking Meet! – #DusKaDum</b>{" "} */}
                    <span role="img" aria-label="tada">
                      🎉
                    </span>
                  </p>
                  <p className="font-normal !text-gray50 text-sm sm:text-base mb-2">
                    We’ve received your payment and your booking is now
                    confirmed.
                  </p>
                  <p className="font-normal !text-gray50 text-sm sm:text-base mb-2">
                    <span role="img" aria-label="envelope_with_arrow">
                      📩
                    </span>{" "}
                    Please check your email and WhatsApp for the event details
                    and guest pass confirmation.
                  </p>
                  <p className="font-normal !text-gray50 text-sm sm:text-base mb-2">
                    If you don’t receive the email within a few minutes, kindly
                    check your spam or promotions folder.
                  </p>
                  {/*   <p className="font-normal !text-gray50 text-sm sm:text-base mb-6">
                  We can’t wait to celebrate with you!{" "}
                  <span role="img" aria-label="dancer">
                    💃
                  </span>
                </p> */}
                </div>
                <img src={LuckyGift} className="img-fluid" alt="lucky box" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Congrats
